import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enUS from './locales/en-US.json';
import esES from './locales/es-ES.json';
import ptBR from './locales/pt-BR.json';

const resources = {
  'en-US': { translation: enUS },
  'es-ES': { translation: esES },
  'pt-BR': { translation: ptBR }
};

// Check if we have a stored language preference
const storedLang = localStorage.getItem('i18nextLng') || localStorage.getItem('preferredLocale');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLang || undefined, // Use stored language if available
    fallbackLng: 'en-US',
    supportedLngs: ['en-US', 'es-ES', 'pt-BR'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;

// Locale-aware date formatting
export const formatDate = (dateStr, locale = i18n.language) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (dateStr, locale = i18n.language) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
};

export const formatTime = (dateStr, locale = i18n.language) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit'
  });
};

// Locale-aware number formatting
export const formatNumber = (num, locale = i18n.language) => {
  if (num === null || num === undefined) return '';
  return new Intl.NumberFormat(locale).format(num);
};

export const formatCurrency = (amount, locale = i18n.language, currency = 'USD') => {
  if (amount === null || amount === undefined) return '';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency
  }).format(amount);
};

// Language labels in native language
export const LANGUAGE_OPTIONS = [
  { code: 'en-US', label: 'English', flag: '🇺🇸' },
  { code: 'es-ES', label: 'Español (España)', flag: '🇪🇸' },
  { code: 'pt-BR', label: 'Português (Brasil)', flag: '🇧🇷' }
];
